import { ApiClientError } from '~/ApiClient';
import Price from '~/utils/Price';

import FinalCalculation from './FinalCalculation';
import { mapError } from './mapError';

export interface RawFinalCalculation {
	internationalReferencePrices: { value: string; currency: string } | null;
	proposedCifPrice: { value: string; currency: string } | null;
	countryOfOriginExFactoryPrice: { value: string; currency: string } | null;
	finalPrice: { value: string; currency: string } | null;
	emptyResultReason: ApiClientError[];
}

export default function mapFinalCalculation(finalCalculation: RawFinalCalculation): FinalCalculation {
	const {
		internationalReferencePrices,
		proposedCifPrice,
		countryOfOriginExFactoryPrice,
		finalPrice,
		emptyResultReason,
	} = finalCalculation;

	return new FinalCalculation(
		internationalReferencePrices !== null
			? new Price(internationalReferencePrices.value, internationalReferencePrices.currency)
			: null,
		proposedCifPrice !== null ? new Price(proposedCifPrice.value, proposedCifPrice.currency) : null,
		countryOfOriginExFactoryPrice !== null
			? new Price(countryOfOriginExFactoryPrice.value, countryOfOriginExFactoryPrice.currency)
			: null,
		finalPrice !== null ? new Price(finalPrice.value, finalPrice.currency) : null,
		emptyResultReason.map(mapError)
	);
}
